'use client';

import { Button } from '#/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger
} from '#/components/ui/dropdown-menu';
import { Icons } from '../icons';

export interface MoreAction {
  title: string;
  onClick: () => void;
  disabled?: boolean;
}

interface ToolbarMoreActionsProps {
  actions: MoreAction[];
  className?: string;
}

export function ToolbarMoreActions({
  actions = [],
  className
}: ToolbarMoreActionsProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" className={className}>
          <Icons.moreVertical className="h-4 w-4" />
          <span className="sr-only">Open menu</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-[160px]">
        {actions.map((a) => (
          <DropdownMenuItem
            key={a.title}
            onClick={a.onClick}
            disabled={a.disabled}
          >
            {a.title}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
